import get from 'lodash/get'
import { ROX_LENS_PART_NUMBER_QUERY_PARAM } from '@/scripts/constants/pdp'
import { normalizeCarousel, normalizePdpProduct } from '@/scripts/normalizer'
import axios from 'axios'
import qs from 'qs'
import { getJSONByElementId } from '../data'
import wcs from '@/scripts/libs/wcs'
import makeDebug from 'debug'
const debug = makeDebug('pdp')
import { ProductDetailsPageHelper } from '@/scripts/libs/pdp'
import { Product } from '@/types/pdp'

import TealiumTrackingModule from '@/scripts/libs/tracking/tealium'
import {
  TRACKER_ERROR_SOURCE_CLIENT,
  TRACKER_ERROR,
  TRACKER_ERROR_CODE_PDP,
} from '@/scripts/constants/tracker'

class WcsPdp implements ProductDetailsPageHelper {
  fetchCarousel = async (product: Product) => {
    const { groupKey } = product
    if (!groupKey) return []

    let carousel = null
    const carouselEndPoint = wcs.getEndPoint('carousel')
    const carouselEndPointParameterized = carouselEndPoint.replace('$groupKey', `${groupKey}`)
    const queryParams = qs.parse(window.location.search)
    const param = get(queryParams, ROX_LENS_PART_NUMBER_QUERY_PARAM, null)
    try {
      if (param) {
        carousel = await axios.get(carouselEndPointParameterized, {
          params: {
            roxLensPartNumber: param,
          },
        })
      } else {
        carousel = await axios.get(carouselEndPointParameterized)
      }

      return normalizeCarousel(carousel.data.carousel)
    } catch (error: any) {
      TealiumTrackingModule.staticTrackEvent({
        event: TRACKER_ERROR,
        value: {
          id: 'Error',
          Error_Source: TRACKER_ERROR_SOURCE_CLIENT,
          Error_Code: TRACKER_ERROR_CODE_PDP,
          Error_Message: error.name,
          Error_Details: error.message,
        },
      })
      return []
    }
  }

  fetchPDPDataFromService = async (catEntryId: number) => {
    if (catEntryId) {
      // TODO: change endpoint name
      const endpoint = wcs.getEndPoint('pdp').replace('$catalogEntryId', `${catEntryId}`)
      const { data: productData } = await axios.get(endpoint)
      const normalizedProductData = normalizePdpProduct(productData?.product)
      return normalizedProductData
    }
  }

  fetchProductDescription = async (parentCatEntryId: string): Promise<string> => {
    const endpoint = wcs.getEndPoint('pdpLongDescription')
    const { storeId, langId } = wcs.getStoreConfig()

    const { data } = await axios.get<{ productLongDescription: string }>(endpoint, {
      params: { parentCatEntryId, storeId, langId },
    })
    return data.productLongDescription
  }

  getPDPDataFromPage = function () {
    const productData = getJSONByElementId('data_pdp')
    const normalizedProductData = normalizePdpProduct(productData)
    return normalizedProductData
  }

  fetchAvailabilityData = async (catEntryId: number) => {
    const endpoint = wcs
      .getEndPoint('productAvailability')
      ?.replace('$catalogEntryId', `${catEntryId}`)
    const response = await axios.get(endpoint)

    return response.data
  }

  fetchLensDetails = async (cLens: string) => {
    const { storeId } = wcs.getStoreConfig()
    const url = wcs
      .getEndPoint('draggableLensesEspotContent')
      .replace('{storeId}', storeId)
      .replace('{cLens}', cLens)

    try {
      const { data } = await axios.get(url)
      // TODO: map title information from ESPOT
      return {
        description:
          data?.MarketingSpotData[0] &&
          data?.MarketingSpotData[0]?.baseMarketingSpotActivityData[0]
            ?.marketingContentDescription[0]?.marketingText,
      }
    } catch (e) {
      debug(e)
      return {}
    }
  }
}

export default new WcsPdp()
